import { useNotification } from "../components/NotificationContext";
import { useEffect, useRef } from "react";
import { getSignalRService } from "./SignalRSingleton";
import { MessageTypes } from "./SignalRMessageTypes";
import { useAuth } from "../AuthContext";
import eventBus from "../components/eventBus";
import Logger from "../utils/Logger";

const SignalRListener = () => {
  const { showNotification } = useNotification();
  const { authenticated, getToken } = useAuth();
  const hasStartedRef = useRef(false);
  const signalRServiceRef = useRef(null);

  const notificationDuration = 10 * 1000; // 10 seconds

  useEffect(() => {
    if (!authenticated && hasStartedRef.current) {
      signalRServiceRef.current?.stop();
      hasStartedRef.current = false;
    }
  }, [authenticated]);

  useEffect(() => {
    let cancelled = false;

    const startConnection = async () => {
      if (!authenticated || hasStartedRef.current) return;

      const signalRService = getSignalRService(
        showNotification,
        getToken,
        () => authenticated,
      );
      signalRServiceRef.current = signalRService;

      signalRService.onMessage(MessageTypes.Success, function (msg) {
        showNotification(msg, "success", notificationDuration);
      });

      signalRService.onMessage(MessageTypes.Error, function (msg) {
        showNotification(msg, "error", notificationDuration);
      });

      signalRService.onMessage(MessageTypes.Warning, function (msg) {
        showNotification(msg, "warning", notificationDuration);
      });

      signalRService.onMessage(MessageTypes.Info, function (msg) {
        showNotification(msg, "info", notificationDuration);
      });

      signalRService.onMessage(
        MessageTypes.ReFetchRoomReservations,
        function (msg) {
          Logger.log("Re-fetching room reservations", msg);
          eventBus.emit("reFetchRoomReservations", msg);
        },
      );

      signalRService.onMessage(
        MessageTypes.ReFetchCarReservations,
        function (msg) {
          Logger.log("Re-fetching car reservations", msg);
          eventBus.emit("reFetchCarReservations", msg);
        },
      );

      signalRService.onMessage(
        MessageTypes.WorklogsLockChanged,
        function (msg) {
          Logger.log("Worklogs lock changed", msg);
          // msg expected: { year: number, month: number, locked: boolean }
          eventBus.emit("worklogs-lock-changed", msg);
        },
      );

      await signalRService.start();

      if (!cancelled) hasStartedRef.current = true;
    };

    startConnection();

    return () => {
      cancelled = true;
    };
  }, [authenticated]);

  return null;
};

export default SignalRListener;
